import { createObj } from "../fable_modules/fable-library.3.7.12/Util.js";
import { map } from "../fable_modules/fable-library.3.7.12/Array.js";
import { toArray } from "../fable_modules/fable-library.3.7.12/Map.js";

export function ofMap() {
    return (arg_1) => createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], toArray(arg_1)));
}

